import { createSlice } from '@reduxjs/toolkit';

const getValidStorageItem = (key) => {
    const val = localStorage.getItem(key);
    if (val === null || val === 'null' || val === 'undefined' || val === '') return null;
    return val;
};

/* Set up initial state */
const initialAuthState = {
    token: getValidStorageItem('token'),
    refreshToken: getValidStorageItem('refreshToken'),
    phone: getValidStorageItem('phone'),
    firstName: getValidStorageItem('firstName'),
    lastName: getValidStorageItem('lastName'),
    organizationName: getValidStorageItem('organizationName'),
    organizationId: getValidStorageItem('organizationId') !== null ? parseInt(getValidStorageItem('organizationId')) : null,
    userRoles: getValidStorageItem('userRoles') !== null ? JSON.parse(getValidStorageItem('userRoles')) : null,
};

/* Set up slice */
const authSlice = createSlice({
    name: 'auth',
    initialState: initialAuthState,
    reducers: {
        login(state, action) {
            /* Populate user role array */
            const userRoles = action.payload.roles.map((item) => {
                return item.pk;
            });

            localStorage.setItem('token', action.payload.token);
            localStorage.setItem('refreshToken', action.payload.refreshToken);
            localStorage.setItem('phone', action.payload.phone);
            localStorage.setItem('firstName', action.payload.firstName);
            localStorage.setItem('lastName', action.payload.lastName);
            localStorage.setItem('organizationName', action.payload.organizationName);
            localStorage.setItem('organizationId', action.payload.organizationId);
            localStorage.setItem('userRoles', JSON.stringify(userRoles));
            
            state.token = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
            state.phone = action.payload.phone;
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.organizationName = action.payload.organizationName;
            state.organizationId = action.payload.organizationId;
            state.userRoles = userRoles;
        },
        logout(state) {
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('phone');
            localStorage.removeItem('firstName');
            localStorage.removeItem('lastName');
            localStorage.removeItem('organizationName');
            localStorage.removeItem('organizationId');
            localStorage.removeItem('userRoles');

            state.token = null;
            state.refreshToken = null;
            state.phone = null;
            state.firstName = null;
            state.lastName = null;
            state.organizationName = null;
            state.organizationId = null;
            state.userRoles = null;
        },
    }
});

export const authActions = authSlice.actions;
export default authSlice;